export default "__VITE_ASSET__BS6Lih0B__"